module.exports = __webpack_public_path__ + "img/zanwu.08187d49.png";